import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useAbility } from '@casl/vue';
import { subject } from '@casl/ability';

export function useCanEditField<TSubject extends string>(
  subjectName: TSubject,
  getSubjectValue: MaybeRefOrGetter<Record<string, unknown>>,
  action: MaybeRefOrGetter<'create' | 'update'>,
) {
  const ability = useAbility();

  const subjectInstance = computed(() => subject(subjectName, toValue(getSubjectValue)));

  const canEditResource = computed(() => ability.can(toValue(action), subjectInstance.value));

  function canEditField(field: string): boolean {
    return ability.can(toValue(action), subjectInstance.value, field);
  }

  return { canEditField, canEditResource };
}
